<template>
  <Modal
    :id="'cmp-distribution-reports-add_extra_result_form'"
    @cancelled="onCancel"
  >
    <template slot="header"></template>
    <template slot="body">
      <div class="form-group">
        <span v-if="showWarning" style="color: red"
          >{{ $t('dist_report_extra_table_message') }}</span
        >

        <Dropdown
          :options="resultTableTV"
          class="dt-dropdown m2"
          :placeholder="'Extra result by table for each'"
          :selected="
            resultTableTV.find((x) => x.value == filterSelectionData.chapter)
          "
          v-on:selectedChange="(e) => onDropdownChange('chapter', e)"
          box
          :listHeight="350"
          :showValidationIcons="'false'"
        ></Dropdown>

        <Dropdown
          :options="reportByTV"
          class="m2"
          :placeholder="$t('group_by')"
          :selected="
            reportByTV.find((x) => x.value == filterSelectionData.group_by)
          "
          v-on:selectedChange="(e) => onDropdownChange('group_by', e)"
          box
          deslect
          :listHeight="350"
          showValidationIcons
          required
          immediateValidation
          @validated="(e) => onValidation('group_by', e)"
        ></Dropdown>
        <div style="padding-top:25px">
          <div class="checkbox-container">
            <div class="select-checkbox">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  :name="'top_ten'"
                  :id="'top_ten'"
                  @change="checkboxChange"
                  :checked="filterSelectionData.top_ten"
                />
                <div class="checkmark"></div>
              </div>
            </div>
            <div class="select-text">{{ $t('top_ten') }}</div>
          </div>
        </div>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $dft.snakeCaseToWords("cancel") }}
      </button>
      <button
        v-if="!loadingGif"
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
        @click.stop="onSave"
      >
        {{ $dft.snakeCaseToWords("ok") }}
      </button>
      <button
        v-if="loadingGif"
        :class="{ disabled: !isFormValid }"
        class="dt-button v1 s6"
      >
        <img src="static/icons/loading.gif" />
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "../../../../dt-plugins/modal/modal";
import { ReportService } from "../../services/reports.service";
import InputField from "../../../../plugins/text-field/input-field";
import { createTV } from "../../../../models/text-value.model";
import { EventHooks } from "../../../../plugins/text-field";
export default {
  components: {
    InputField,
    Modal,
  },
  props: ["filteredData"],
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
        validationEvent: EventHooks.OnKeyup,
        isModel: true,
      },
      loadingGif: false,
      validationResult: {},
      filterSelectionData: {
        group_by: null,
        chapter: null,
        top_ten: null,
      },
      filter: {
        accounts: [],
        account_texts: [],
        shops: [],
        countries: [],
        country_texts: [],
        formats: [],
        format_texts: [],
        labels: [],
        label_texts: [],
        releases: [],
        release_texts: [],
        products: [],
        product_texts: [],
        tracks: [],
        track_texts: [],
        physical: 0,
        digital: 0,
        usage_types: [],
        digital_bundle: 0,
        digital_track: 0,
        thirdparty: 0,
        performance: 0,
      },
      showWarning: false,
      token: null,
    };
  },
  mounted: function () {},
  computed: {
    resultTableTV: function () {
      return [
        { text: "Account", value: "Account" },
        { text: "Product/Track", value: "Product / Track" },
        { text: "Catalog No", value: "Catalog No" },
        { text: "Country", value: "Country" },
        { text: "Format", value: "Format" },
        { text: "Label", value: "Label" },
        { text: "Releases", value: "Releases" },
        { text: "Sales Period", value: "Sales Period" },
        { text: "Shop", value: "Shop" },
        { text: "Year", value: "Year" },
      ];
    },
    reportByTV: function () {
      return [
        { text: "Account", value: "Account" },
        { text: "Product/Track", value: "Product / Track" },
        { text: "Catalog No", value: "Catalog No" },
        { text: "Country", value: "Country" },
        { text: "Format", value: "Format" },
        { text: "Label", value: "Label" },
        { text: "Releases", value: "Releases" },
        { text: "Sales Period", value: "Sales Period" },
        { text: "Shop", value: "Shop" },
        { text: "Year", value: "Year" },
      ];
    },
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e.valid);
    },
  },

  methods: {
    checkboxChange() {
      this.filterSelectionData.top_ten = !this.filterSelectionData.top_ten;
    },
    setFilter() {
      this.filter.accounts = [];
      this.filter.account_texts = [];
      this.filter.shops = [];
      this.filter.countries = [];
      this.filter.country_texts = [];
      this.filter.formats = [];
      this.filter.format_texts = [];
      this.filter.labels = [];
      this.filter.label_texts = [];
      this.filter.releases = [];
      this.filter.release_texts = [];
      this.filter.products = [];
      this.filter.product_texts = [];
      this.filter.tracks = [];
      this.filter.track_texts = [];
      this.filteredData.labels.forEach((l) => {
        this.filter.labels.push(l.label_id);
        this.filter.label_texts.push(l.label_name);
      });
      this.filteredData.accounts.forEach((a) => {
        this.filter.accounts.push(a.account_id);
        this.filter.account_texts.push(a.account_name);
      });
      this.filteredData.releases.forEach((r) => {
        this.filter.releases.push(r.release_id);
        this.filter.release_texts.push(r.release_name);
      });
      this.filteredData.tracks.forEach((t) => {
        this.filter.tracks.push(t.track_id);
        this.filter.track_texts.push(t.track_name);
      });
      this.filteredData.countries.forEach((c) => {
        this.filter.countries.push(c.country_id);
        this.filter.country_texts.push(c.country_fullname);
      });
      this.filteredData.products.forEach((p) => {
        this.filter.products.push(p.product_id);
        this.filter.product_texts.push(p.product_name);
      });
      this.filteredData.formats.forEach((f) => {
        this.filter.formats.push(f.format_id);
        this.filter.format_texts.push(f.format_name);
      });
      this.filteredData.shops.forEach((s) => {
        this.filter.shops.push(s.shop_name);
      });
      this.filter[this.filteredData.period_type] = [
        this.filteredData.from_date,
        this.filteredData.to_date,
      ];
      this.filter.physical = this.filteredData.physical;
      this.filter.digital = this.filteredData.digital;
      this.filter.usage_types = this.filteredData.usage_types;
      this.filter.digital_bundle = this.filteredData.digital_bundle;
      this.filter.digital_track = this.filteredData.digital_track;
      this.filter.thirdparty = this.filteredData.thirdparty;
      this.filter.performance = this.filteredData.performance;
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
    getFilterSelectionData: async function () {
      const result = await ReportService.getFilterSelectionData();

      this.filterSelectionData = {
        ...result.data,
      };
    },
    onSave: async function () {
      this.loadingGif = true;
      this.setFilter();
      console.log("filter", this.filter);
      let curTime = new Date().getTime();
      this.token = "summarized_report_" + curTime;
      const result = await ReportService.getSummarizedReports({
        filter: this.filter,
        chapter: this.filterSelectionData.chapter,
        group_by: this.filterSelectionData.group_by,
        top_ten: this.filterSelectionData.top_ten ? 1 : 0,
        token: this.token,
      });
      setTimeout(() => {
        ReportService.checkReportStatus(this.token).then((result) => {
          if (result.data.status == "success") {
            ReportService.getReportResult(this.token).then((result) => {
              console.log("report", result.data.data);
              this.loadingGif = false;

              this.$emit("emitData", { data: result.data, token: this.token });
            });
          }
        });
      }, 3000);
    },
    onDropdownChange: function (name, value) {
      this.filterSelectionData[name] = value.value;
    },

    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss" >
.cmp-distribution-reports-add_extra_result_form {
  .dt-modal--body {
    margin-left: 0px;
    padding-right: 40px;
  }
  .dt-modal--options {
    button {
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 0px 10px;
      }
    }
  }
  .checkbox-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    height: 30px;
    .select-checkbox {
      padding-right: 5px;
    }
  }
}
</style>
